import { ApiHeaders } from "./Helper"
import { resolve } from "./Resolver"
import helper from "./Helper"
import axios from "axios"

const ApiCall = async (method, url, data, token) => {
    return await resolve(
        axios({
            method: method,
            url: helper.ApiUrl + url,
            headers: ApiHeaders(token),
            data: data
            
        })
            .then(response => response.data)
            .catch(error => error.response.data)
    )

}

export default ApiCall